import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { OrganizationState } from '@reducers/organizations-item';
import { OrganizationTitleState } from '@reducers/organization-title';

export const getOrganization = (state: RootState): OrganizationState => state.organizationsItem;
export const getOrganizationItem = createSelector(getOrganization, (org) => org?.data);
export const getOrganizationId = createSelector(getOrganization, (org) => org?.data?.id);

export const getOrganizationTitle = createSelector(
  (state: RootState): OrganizationTitleState => state.organizationTitle, (org) => org?.data?.title,
);
